<template>
    <el-dialog :visible.sync="visible" title="法人申请审核" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '10px' : '80px'">
            <el-form-item label="法人申请状态" prop="verifyStatus">
                <el-select v-model="juridicalApplyStatus" placeholder="审核状态(">
                    <el-option v-for="item in allJuridicalApplyStatus"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="法人姓名:" prop="legalName">
                <el-input v-model="dataForm.legalName" placeholder="法人姓名" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="公司名称:" prop="companyName">
                <el-input v-model="dataForm.companyName" placeholder="公司名称" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="公司地址:" prop="companyAddress">
                <el-input v-model="dataForm.companyAddress" placeholder="公司地址" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="社会信用代码" prop="creditCode">
                <el-input v-model="dataForm.creditCode" placeholder="社会信用代码" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="成立日期" prop="foundDate">
                <el-input v-model="dataForm.foundDate" placeholder="成立日期" readonly="readonly"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                allJuridicalApplyStatus: [{
                    value: 2,
                    label: '通过'
                }, {
                    value: 3,
                    label: '拒绝'
                }],
                juridicalApplyStatus: 2,
                dataForm: {
                    id: '',
                    juridicalApplyStatus: ''
                },
                //图片上传
                headers: {
                    token: this.cookie.get('token')
                },
                dialogImageUrl: '',
                dialogVisible: false,
                hideUpload: false,
                imgsHideUpload: false,
                // mainFileList: [{
                //   name: 'main.jpeg',
                //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                // }]
                mainFileList: [],
                imgsFileList: [],
                uploadUrl: ''
            }
        },
        computed: {
            dataRule() {
                return {
                    name: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    avatar: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    gender: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    level: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.mainFileList = []
                    this.imgsFileList = []
                    this.hideUpload = false
                    console.log(id)
                    this.dataForm.id = id
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`pms/umsmember/getJuridicalCompanyMsg/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    console.info(this.dataForm)
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.dataForm.juridicalApplyStatus = this.juridicalApplyStatus
                    console.log(this.dataForm)
                    this.$http[!this.dataForm.id ? 'post' : 'put']('pms/umsmember/juridicalApplyStatus', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false}),
        }
    }
</script>
